import flatpickr from "flatpickr";

(function($) {
    const form = $(".contact-form");
    const currentDate = new Date();

    flatpickr(".pickup-date", {
        disable: [
            function(date) {
                // return true to disable get (0 indexed)
                return date.getDay() === 0 || date.getDay() === 6;
            }
        ],

        minDate: currentDate.setDate(currentDate.getDate() + 1),

        locale: {
            firstDayOfWeek: 1 // start week on Monday
        }
    });

    function localstorage() {
        let mod = 'mod';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (e) {
            return false;
        }
    }

    let contactForm = function(form, opts) {
        let _this = form;
        let isCustomer = null;
        let storageKey = "prideDisposalContactForm";
        let formState = {};
        let $customerStatusSelect = $('[name="prideCustomer"]');
        let $formPurposeSelect = $('[name="howCanWeHelp"]');
        let $inputs = _this.find("input, select, textarea");
        let pickupFields = _this.find(".pickup");

        let _init = function() {
            $customerStatusSelect.change(_onCustomerStatusChange);
            $formPurposeSelect.change(_onFormPurposeChange);
            $inputs.change(_onFormValueUpdate);
        };

        let _onLoad = function() {
          if (localstorage() && localStorage.getItem(storageKey) !== 'null') {
                let formValues = formState = JSON.parse(localStorage.getItem(storageKey)) || {};

                for (let val in formValues) {
                    let input = _this.find('*[name="'+ val + '"]');

                      if (input.length && input.attr('type') !== "hidden") {
                        if (input.attr('type') === "radio" || input.attr('type') === "checkbox" || input[0].tagName === "SELECT") {
                          input.val([formValues[val]]);
                        } else if (input.attr('type') === "file") {

                        } else {
                          input.val(formValues[val]);
                        }
                      }
                }
            }

            _onCustomerStatusChange()
        };

        let _onFormValueUpdate = function() {
            if ($(this).attr('type') === "checkbox" || $(this).attr('type') === "radio") {
                formState[this.name] = $('[name="'+this.name+'"]').filter(':checked').val();
            } else {
              formState[this.name] = $(this).val();
            }

            localStorage.setItem(storageKey, JSON.stringify(formState));
        };

        let _onCustomerStatusChange = function() {
            isCustomer = $customerStatusSelect.filter(':checked').val();

            let $customerFields = _this.find(".customer");

            if (isCustomer == "Yes") {
                $customerFields.show();
                $customerFields.find('[name="serviceAddress"]').prop('required',true);
                _onFormPurposeChange();
            } else {
                $customerFields.hide();
                $customerFields.find('[name="serviceAddress"]').removeAttr('required');
                $(".support").show();
            }
        };

        let _onFormPurposeChange = function() {
            let purpose = $formPurposeSelect.val();

            if (purpose == "Pickup Request") {
                pickupFields.show();
                $(".support").hide();
            } else {
                pickupFields.hide();
                $(".support").show();
            }
        };

        let _onSubmit = function() {
            localStorage.setItem(storageKey, null);
            //could do some extra validation here
        };

        _onLoad();
        _init();
    };

    contactForm(form);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/contactForm.js